/**
 * Profile incompleteness for Google / OAuth users.
 * Matches signup required fields (except password).
 */
export const isProfileIncomplete = (profile, authUser = null) => {
  if (!profile && !authUser) return true

  const firstName = String(profile?.first_name || profile?.firstName || '').trim()
  const lastName = String(profile?.last_name || profile?.lastName || '').trim()
  const mobile = String(profile?.mobile || profile?.phone || '').trim()
  const email = String(
    profile?.email || authUser?.email || authUser?.user_metadata?.email || ''
  ).trim()
  const dob = profile?.date_of_birth || profile?.dateOfBirth || null
  const gender = String(profile?.gender || '').trim()

  return !firstName || !lastName || !mobile || !email || !dob || !gender
}

const isNonEmailProvider = (provider) => {
  const p = String(provider || '').toLowerCase()
  return !!p && p !== 'email' && p !== 'phone'
}

export const isOAuthUser = (authUser) => {
  if (!authUser) return false

  const identities = authUser.identities || []
  if (identities.some((identity) => isNonEmailProvider(identity?.provider))) {
    return true
  }

  const providers = authUser.app_metadata?.providers
  if (Array.isArray(providers) && providers.some((p) => isNonEmailProvider(p))) {
    return true
  }

  if (isNonEmailProvider(authUser.app_metadata?.provider)) {
    return true
  }

  const meta = authUser.user_metadata || {}
  if (meta.iss && String(meta.iss).includes('accounts.google.com')) return true
  if (isNonEmailProvider(meta.provider)) return true
  if (meta.avatar_url || meta.picture) {
    if (meta.iss || meta.sub || meta.full_name || meta.name) return true
  }

  return false
}

/** Show complete-profile prompt for Google/OAuth users with missing required fields. */
export const shouldPromptCompleteProfile = (profile, authUser) =>
  isOAuthUser(authUser) && isProfileIncomplete(profile, authUser)

export const NEEDS_PROFILE_COMPLETION_KEY = 'needsProfileCompletion'

export const getNeedsProfileCompletionFlag = () => {
  try {
    return localStorage.getItem(NEEDS_PROFILE_COMPLETION_KEY) === '1'
  } catch {
    return false
  }
}

export const setNeedsProfileCompletionFlag = (needed) => {
  try {
    if (needed) localStorage.setItem(NEEDS_PROFILE_COMPLETION_KEY, '1')
    else localStorage.removeItem(NEEDS_PROFILE_COMPLETION_KEY)
  } catch {
    /* ignore */
  }
}
